import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * Shared vertical offset for the mobile similar-inquiries panel, so the calendar gutter and every
 * inquiry column scroll as one grid. Provided by the panel component rather than in root, so each
 * panel keeps its own offset.
 */
@Injectable()
export class BaseCustomerSimilarInquiriesMdScrollService {
  private readonly scrollTopSubject = new BehaviorSubject<number>(0);

  readonly scrollTop$: Observable<number> = this.scrollTopSubject.pipe(distinctUntilChanged());

  setScrollTop(value: number): void {
    this.scrollTopSubject.next(value);
  }
}
